import { auth } from '../../src/firebase.js';
import { onAuthStateChanged as fbOnAuthStateChanged, signOut as fbSignOut } from "firebase/auth"; // Renamed to avoid conflict

/**
 * Authentication Helper Service
 * Provides standardized checks and actions using the Firebase Auth SDK.
 */

/**
 * Returns the current authenticated user's basic information.
 * @returns {{uid: string, email: string} | null}
 */
export function getCurrentUser() {
    const user = auth.currentUser;
    if (user) {
        return {
            uid: user.uid,
            email: user.email
        };
    }
    return null;
}

/**
 * Synchronous check to verify if a user session exists.
 * @returns {boolean}
 */
export function isAuthenticated() {
    return !!auth.currentUser;
}

/**
 * Signs out the current user and redirects to the home page.
 * Redirection is handled via the app's internal navigation event.
 */
export async function signOut() {
    try {
        await fbSignOut(auth);
        window.dispatchEvent(new CustomEvent('fg:navigate', { detail: { page: 'home' } }));
    } catch (error) {
        console.error("[Auth] Sign out failed:", error);
        throw error;
    }
}

/**
 * Listener that executes a callback whenever the auth state changes.
 * @param {Function} callback - Receives user info {uid, email} or null.
 */
export function onAuthStateChanged(callback) {
    return fbOnAuthStateChanged(auth, (user) => {
        callback(user ? { uid: user.uid, email: user.email } : null);
    });
}

/**
 * Used on protected pages to force a redirect if no user is found.
 */
export function redirectIfNotAuthenticated() {
    if (!auth.currentUser) {
        window.dispatchEvent(new CustomEvent('fg:navigate', { detail: { page: 'login' } }));
        return true;
    }
    return false;
}